import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { Color } from 'shared/utils/colors';

export type DragDropVariant = 'default' | 'subtle';

const dropzoneBaseSx: SxProps<Theme> = {
  width: '100%',
  boxSizing: 'border-box',
};

const defaultDropzoneSx: SxProps<Theme> = {
  ...dropzoneBaseSx,
  minHeight: '67px',
  background: Color.solidGray,
  left: 0,
  top: 0,
  fontSize: '0.875rem',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '16px 16px 16px 0',
  overflowWrap: 'break-word',
  wordWrap: 'break-word',
  borderRadius: '5px',
  border: '2px solid transparent',
  color: Color.lightGray,
  fontWeight: 400,
};

/** Thin outline, same weight as the previous 2px border. Drawn outside so tiles do not shift. */
const SUBTLE_OUTLINE_PX = 2;

// No padding or margin: tiles line up with the field label wherever the drop
// zone is placed. The drag-over line is a box-shadow, so it takes no layout space.
const subtleDropzoneSx: SxProps<Theme> = {
  ...dropzoneBaseSx,
  borderRadius: '8px',
  transition: (theme) =>
    theme.transitions.create(['box-shadow', 'background-color']),
};

const subtleDropzoneDraggingSx: SxProps<Theme> = {
  ...subtleDropzoneSx,
  backgroundColor: 'action.hover',
  boxShadow: (theme) =>
    `0 0 0 ${SUBTLE_OUTLINE_PX}px ${theme.palette.primary.main}`,
};

export const resolveDropzoneSx = (
  variant: DragDropVariant,
  isDraggingFilesOver: boolean
): SxProps<Theme> => {
  const baseSx = variant === 'subtle' ? subtleDropzoneSx : defaultDropzoneSx;

  if (!isDraggingFilesOver) {
    return baseSx;
  }

  if (variant === 'subtle') {
    return subtleDropzoneDraggingSx;
  }

  return {
    ...baseSx,
    borderColor: 'primary.main',
  };
};